import React from 'react';

import FatigueAssessmentPage from "./FatigueAssessmentPage";
import { fatigueAssessmentOnBehalf } from "./FatigueAssessmentPageSelector";
import FormContents from "./FormContents";

const FatigueAssessmentOnBehalfForm = () => {

    return (
        <FatigueAssessmentPage selectedPage={fatigueAssessmentOnBehalf}>
            <FormContents onBehalf={true}></FormContents>
        </FatigueAssessmentPage>
    );
}

export default FatigueAssessmentOnBehalfForm;
